if (!customElements.get('wishlist-page')) {
  customElements.define(
    'wishlist-page',
    class WishlistPage extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('[data-wishlist-grid]');
        this.emptyState = this.querySelector('[data-wishlist-empty]');
        this.status = this.querySelector('[data-wishlist-status]');
        this.heading = this.querySelector('h1');
        this.unsubscribe = subscribe(Wishlist.EVENT, this.onWishlistChange.bind(this));
        this.renderAll();
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      async renderAll() {
        const seen = new Set();
        const items = Wishlist.read().filter((item) => {
          if (seen.has(item.id)) return false;
          seen.add(item.id);
          return true;
        });

        if (items.length === 0) {
          this.finish([]);
          return;
        }

        const cards = await Promise.all(items.map((item) => this.fetchCard(item)));

        const missing = [];
        cards.forEach((card, index) => {
          if (card) {
            this.grid.appendChild(card);
          } else {
            missing.push(items[index].id);
          }
        });

        // A saved product that no longer resolves (deleted, unpublished,
        // handle renamed) is dropped so it stops being fetched every visit.
        if (missing.length) {
          Wishlist.write(items.filter((item) => !missing.includes(item.id)));
        }

        this.finish(cards.filter(Boolean));
      }

      async fetchCard(item) {
        try {
          const url = `${this.dataset.productUrlBase}${encodeURIComponent(item.handle)}?section_id=${
            this.dataset.cardSectionId
          }`;
          const response = await fetch(url);
          if (!response.ok) return null;
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          return doc.querySelector('.wishlist-card');
        } catch (error) {
          return null;
        }
      }

      finish() {
        this.classList.remove('is-loading');
        this.classList.toggle('is-empty', this.grid.children.length === 0);
      }

      onWishlistChange({ items }) {
        const keep = new Set(items.map((item) => item.id));

        this.grid.querySelectorAll('[data-wishlist-id]').forEach((card) => {
          if (keep.has(card.dataset.wishlistId)) return;

          const hadFocus = card.contains(document.activeElement);
          const fallback = card.nextElementSibling || card.previousElementSibling;
          this.announce(card.dataset.wishlistTitle);
          card.remove();

          if (hadFocus) {
            const next = fallback && fallback.querySelector('.wishlist-heart__button');
            (next || this.heading).focus();
          }
        });

        this.finish();
      }

      announce(title) {
        if (!this.status || !title) return;
        this.status.textContent = (this.dataset.removedLabel || '[product]').replace('[product]', title);
      }
    }
  );
}
